const { InnerBlocks } = wp.blockEditor;

export default function save({ attributes }) {
  return (
    <section
      className="Tab-content"
      id={attributes.parentTabId}
      data-plans-id={attributes.plansId}
    >
      <InnerBlocks.Content />
    </section>
  );
}
